// Small wrapper around fetch for the app's JSON API. Requests go to the same
// site the page was loaded from (the dev server proxies /api to the backend),
// so the login cookie is sent automatically.

import { translateNow } from './langState';
import { sessionId } from './analytics';

export class ApiError extends Error {
  constructor(message, status, data) {
    super(message);
    this.status = status;
    this.data = data;
  }
}

export async function api(path, { method = 'GET', body, headers = {} } = {}) {
  let res;
  try {
    res = await fetch(`/api${path}`, {
      method,
      // The visit id lets a sign-up be credited to the page visit it came from.
      headers: { 'X-MM-Sid': sessionId().id, ...(body === undefined ? {} : { 'Content-Type': 'application/json' }), ...headers },
      body: body === undefined ? undefined : JSON.stringify(body),
    });
  } catch {
    throw new ApiError(translateNow('Could not reach the server. Check your connection and try again.'), 0);
  }

  if (res.status === 204) return null;
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    // The demo can't import or save some things; the journal shows a sign-up prompt.
    if (res.status === 403 && data && data.demo) window.dispatchEvent(new CustomEvent('mm-demo-gate'));
    // A Pro feature on the Free plan: the journal offers the plans (Plans.js).
    if (res.status === 402 && data && data.code === 'pro') window.dispatchEvent(new CustomEvent('mm-pro-gate', { detail: { feature: data.feature } }));
    throw new ApiError(translateNow((data && data.message) || 'Something went wrong. Please try again.'), res.status, data);
  }
  return data;
}
